import { render } from "./FacturaForm.vue?vue&type=template&id=6b2c69dc&scoped=true"
import script from "./FacturaForm.vue?vue&type=script&lang=js"
export * from "./FacturaForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=6b2c69dc&scoped=true&lang=css"
import "./FacturaForm.vue?vue&type=style&index=1&id=6b2c69dc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2c69dc"]])

export default __exports__